




































import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'
import SessionDuration from 'components/presenter/item/session/SessionDuration.vue'
import { Session, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    SessionDuration
  }
})
export default class AttendeeSessionResult extends Vue {
  formatDate = date.formatDate

  @Prop()
  readonly session!: Session

  @Prop()
  readonly attendee!: SessionAttendee

  @Prop()
  readonly points!: number

  @Prop()
  readonly pointsTotal!: number

  get startedAt () {
    return this.attendee.startedAt || (this.session.startedAt && this.session.startedAt > this.attendee.createdAt ? this.session.startedAt : this.attendee.createdAt)
  }

  get percent () {
    return this.points * 100 / Math.max(1, this.pointsTotal)
  }

  get percentFraction () {
    return (this.percent * 10) % 10
  }
}
